import { Button, TextField } from '@material-ui/core';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { styled } from '@mui/material/styles';
import * as React from 'react';
import addTerms from '../../actions/admin/addTerms';
import { sendRequest } from '../../api/websocketApi';
import useStore from '../../store/store';
import Dialog from '../Dialog';

interface AddTermsDialogProps {
    open: boolean;
    onClose: () => void;
}

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const AddTermsDialog = ({ open, onClose }: AddTermsDialogProps) => {
    const [termsFile, setTermsFile] = React.useState<File | null>(null);
    const [version, setVersion] = React.useState(1);
    const isLoading = useStore((state) => state.isLoading);

    React.useEffect(() => {
        interface APIResponse {
            success: boolean;
            errCode?: 'invalid_token' | 'auth_failed';
            errDetails?: string;
            content?: string;
            extension?: string;
            version?: number;
        }

        sendRequest(
            {
                endpoint: '/terms/get',
            },
            (response: APIResponse) => {
                if (response.success && response.version) {
                    setVersion(response.version + 1);
                }
            }
        );
    });

    const handleTermsFileChange = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        const uploadedFile = event.target.files?.[0];
        if (uploadedFile) {
            setTermsFile(uploadedFile);
        }
    };

    const handleClose = () => {
        if (isLoading) {
            return;
        }
        setTermsFile(null);
        onClose();
    };

    const handleSubmit = async (e: React.SyntheticEvent) => {
        e.preventDefault();

        if (termsFile) {
            await addTerms({
                terms: termsFile,
                version,
            });
        }

        handleClose();
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            title={'Upload Terms & Conditions'}
            onSubmit={handleSubmit}
            submitDisabled={!termsFile || isLoading}
        >
            <Button
                color="primary"
                component="label"
                role={undefined}
                variant="contained"
                tabIndex={-1}
                startIcon={<CloudUploadIcon />}
                style={{
                    marginTop: '1rem',
                    marginBottom: '1rem',
                    borderRadius: '25px',
                    boxShadow: 'none',
                    textTransform: 'none',
                    fontSize: '16px',
                }}
            >
                Upload Terms & Conditions File
                <VisuallyHiddenInput
                    type="file"
                    accept=".txt"
                    onChange={handleTermsFileChange}
                />
            </Button>
            <p>{termsFile?.name}</p>
            <TextField
                type="number"
                label="Version"
                value={version}
                margin="dense"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setVersion(Number(e.target.value))
                }
                variant="outlined"
            />
        </Dialog>
    );
};

export default AddTermsDialog;
